export enum VillageClientSliceNames {
    REFRESH_VILLAGE_CLIENT_LIST = 'clients/refreshVillageClientList',
    STORE_VILLAGE_CLIENT_LIST = 'clients/storeVillageClientList',
    FETCH_VILLAGE_CLIENT_LIST = 'clients/fetchVillageClientList',
    UPDATE_SINGLE_CLIENT_BAL_AND_SMS = 'clients/updateSingleClientBalAndSms',
    GET_VE_CLIENT_LIST = 'clients/getVeClientList',
    HANDLE_MULTIPLE_VILLAGES_COUNT = 'clients/handleMultipleVillagesCount',
    VILLAGE_CLIENTS = 'villageClients',
    VILLAGE_PREVIOUS_CLIENTS = 'villagePreviousClients',
    SINGLE_CLIENT = 'singleClient',
    OPEN_VILLAGE_PAGE = 'openVillagePage',
    FILTER_SELECTOR = 'filterSelector',
    VILLAGE_SELECTION_INFO = 'villageSelectionInfo',
    VE_CLIENT_LIST = 'veClientList',
    MULTIPLE_VILLAGES_COUNT = 'multipleVillagesCount'
}
